import React from 'react';
import { useIntl } from 'react-intl-next';
import { TimePicker } from '@atlaskit/datetime-picker';
import { DEFAULT_LOCALE } from '../../../../intl-provider/ProFormaIntlProvider';
import { isMobile } from '../../../../jira-common/utils/native/detectDeviceType';
import { times } from '../common/dayTimes';
import { ShortFieldWrapper } from '../common/questionWrappers';
import { TimePickerMobile } from '../mobile/TimePickerMobile';
import { EditTimeMessages, IntlEditTimeMessages } from './EditTimeMessages.intl';
export const EditTime = ({
  id,
  value,
  isInvalid,
  onChange
}) => {
  const intl = useIntl();
  return isMobile() ? /*#__PURE__*/React.createElement(TimePickerMobile, {
    timeValue: value,
    onChange: onChange
  }) : /*#__PURE__*/React.createElement(ShortFieldWrapper, null, /*#__PURE__*/React.createElement(TimePicker, {
    id: id,
    times: times,
    value: value,
    isInvalid: isInvalid,
    onChange: onChange,
    locale: intl.locale || DEFAULT_LOCALE,
    timeIsEditable: true,
    placeholder: intl.formatMessage(IntlEditTimeMessages[EditTimeMessages.TimePlaceholder], {
      time: intl.formatTime(new Date(), {})
    })
  }));
};